// @flow

import type { UnmappedCartItem, CartItem } from "./types";

export const mapCartItem = (datum: UnmappedCartItem, language: string = "el"): CartItem => {
    if (!datum) {
        return {
            id: "",
            code: "",
            title: "",
            price: 0,
            image: "",
            quantity: 1,
            availabilityLabel: "",
        };
    }

    return {
        id: String(datum.id || ""),
        code: datum.code || "",
        title: language === "en" ? (datum.nameEN || "") : (datum.nameEL || ""),
        price: Number(datum.price) || 0,
        image: datum.image || "",
        quantity: Number(datum.quantity) || 1,
        availabilityLabel: datum.availabilityLabel || "",
    };
};